export enum PaymentType {
  WIRE = "Wire",
  PAY_PAL = "Paypal",
}
